import styled from "@emotion/styled";
import { baseTheme } from "@avenue-8/sidekick-ui";
import {
  SIDEBAR_WIDTH_COLLAPSED_PX,
  SIDEBAR_WIDTH_EXPANDED_PX,
} from "@shared/layouts/sidebar-dimensions";

export const MessageBarArea = styled.div<{ $stackedLayout?: boolean }>`
  position: relative;
  grid-area: message-bar;
  justify-self: flex-end;
  width: 100%;
  padding-top: ${(p) => (p.$stackedLayout ? "0" : "1rem")};
  background-color: ${(p) => p.theme.colors.background};
`;

export type ChatLayoutView = "chat" | "new-chat" | "explore" | "focus";

type ContainerProps = {
  $blocked?: boolean;
  $stackedLayout?: boolean;
  $isSidebarOpenDesktop?: boolean;
  $view?: ChatLayoutView;
};

export const Container = styled.div<ContainerProps>`
  position: relative;

  ${(p) =>
    p.$blocked &&
    `
    &::after {
      content: "";
      position: absolute;
      top: 4rem;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 100;
      backdrop-filter: blur(6px);
      -webkit-backdrop-filter: blur(6px);
    }
  `}
  display: grid;
  grid-template-rows:
    4rem [small-top-navbar]
    1fr [chat]
    auto
    auto [disclaimer];
  grid-template-areas:
    "small-top-navbar"
    "chat"
    "message-bar"
    "disclaimer";
  max-height: 100vh;
  min-height: 100vh;
  @supports (height: 100dvh) {
    min-height: 100dvh;
    max-height: 100dvh;
  }
  transition:
    margin-left 0.3s ease-in-out,
    width 0.3s ease-in-out;

  flex: 1;
  overflow: hidden;
  margin: 0 auto;
  width: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `calc(100% - ${SIDEBAR_WIDTH_EXPANDED_PX}px)`
      : `calc(100% - ${SIDEBAR_WIDTH_COLLAPSED_PX}px)`};
  margin-left: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `${SIDEBAR_WIDTH_EXPANDED_PX}px`
      : `${SIDEBAR_WIDTH_COLLAPSED_PX}px`};
  background-color: ${(p) => p.theme.colors.background};
  grid-auto-rows: 0%;

  ${(p) =>
    p.$view === "new-chat" &&
    `
      grid-template-rows:
        4rem
        1fr
        auto
        auto;

      grid-template-areas:
        "small-top-navbar"
        "suggestions"
        "message-bar"
        "disclaimer";
    `}
  ${(p) =>
    p.$view === "explore" &&
    `
      grid-template-rows: 1fr auto auto;
      grid-template-areas:
        "suggestions"
        "message-bar"
        "disclaimer";
      background-color: ${baseTheme.colors.blue5};
    `}
  ${(p) =>
    p.$view === "focus" &&
    `
      grid-template-rows:
        4rem
        1fr
        auto
        auto;

      grid-template-areas:
        "small-top-navbar"
        "suggestions"
        "message-bar"
        "disclaimer";
    `}
  ${(p) => p.theme.media.laptopDown} {
    padding: 0;
    overflow-y: auto;
    width: 100%;
    margin-left: 0;

    ${(p) =>
      p.$stackedLayout &&
      `grid-template-rows:
      1fr [chat]
      auto;
      grid-template-areas:
      "chat"
      "message-bar";

      min-height: auto;
      max-height: auto;`}

    ${(p) =>
      p.$view === "new-chat" &&
      `
      grid-template-rows:
        4.5rem
        1fr
        auto
        auto;

      grid-template-areas:
        "small-top-navbar"
        "suggestions"
        "message-bar"
        "disclaimer";
      min-height: 100vh;
      max-height: 100vh;
      overflow-y: hidden;
      @supports (height: 100dvh) {
        min-height: 100dvh;
        max-height: 100dvh;
      }
    `}
    ${(p) =>
      p.$view === "explore" &&
      `
      grid-template-rows: 1fr auto auto;
      grid-template-areas:
        "suggestions"
        "message-bar"
        "disclaimer";
      background-color: ${baseTheme.colors.blue5};
      min-height: 100vh;
      max-height: 100vh;
      overflow-y: hidden;
      @supports (height: 100dvh) {
        min-height: 100dvh;
        max-height: 100dvh;
      }
    `}
    ${(p) =>
      p.$view === "focus" &&
      `
      grid-template-rows:
        4.5rem
        1fr
        auto
        auto;

      grid-template-areas:
        "small-top-navbar"
        "suggestions"
        "message-bar"
        "disclaimer";
      min-height: 100vh;
      max-height: 100vh;
      overflow-y: hidden;
      @supports (height: 100dvh) {
        min-height: 100dvh;
        max-height: 100dvh;
      }
    `}
  }
`;
